import { StatusSelectWithButton } from 'components';
import { UpdatedBy } from 'components/Cases/Actions/UpdatedBy';

interface CaseDetailsFooterProps {
  onSubmit: (e?: React.BaseSyntheticEvent) => void;
  isFormDisabled: boolean;
  isFormLoading: boolean;
}

const CaseDetailsFooter: React.FC<CaseDetailsFooterProps> = ({
  onSubmit,
  isFormDisabled,
  isFormLoading,
}: CaseDetailsFooterProps) => {
  return (
    <div className="case-details-footer">
      <UpdatedBy />
      <StatusSelectWithButton
        onClick={onSubmit}
        isFormDisabled={isFormDisabled}
        isFormLoading={isFormLoading}
      />
    </div>
  );
};

export default CaseDetailsFooter;
